import React, { useState } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';

import samplePDF from 'assets/pdf/Health & Safety Policy.pdf';

import WhiteNavbar from "components/Navbars/WhiteNavbar.js";

import styled from "styled-components"
import { Link } from 'react-router-dom';
const Button = styled.button`
    max-height: 100px;
    max-width: 100px;
    color: white;
`

const Link2 = styled(Link)`
    color: white;
    text-align: center;
`

export default function HealthAndSafety() {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }

    function changePage(offset) {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
    }

    function previousPage() {
        changePage(-1);
    }

    function nextPage() {
        changePage(1);
    }

    return (
        <>
            <WhiteNavbar />
            <div className="section cd-section section-dark flex-centered" id="contact-us" style={{ marginTop: "5%", }}>

                <div className="content-center flex-centered">
                    <div style={{ textAlign: "center" }}>
                        <Document
                            file={samplePDF}
                            onLoadSuccess={onDocumentLoadSuccess}
                        >
                            <div style={{ overflow: "auto" }}>
                                <Page pageNumber={pageNumber} />
                            </div>
                        </Document>
                        <p style={{ color: "white" }}>
                            Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
                        </p>
                        <div>
                            <Button
                                type="button"
                                disabled={pageNumber <= 1}
                                onClick={previousPage}
                                className="carousel-control"
                            >
                                <span className="fa fa-angle-left" />
                            </Button>
                            <Button
                                type="button"
                                disabled={pageNumber >= numPages}
                                onClick={nextPage}
                                className="carousel-control"
                            >
                                <span className="fa fa-angle-right" />
                            </Button>
                            <div>
                                <Link2 to={samplePDF} target="_blank" download><h4>Download</h4></Link2>
                                <Link2 to={samplePDF} target="_blank"><h4>Open in new page</h4></Link2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}